import { mediaType, status } from '@bt-react/constants'
import { SyncDocument } from 'twilio-sync'
import { ParticipantInformationInterface, SlidePosition, SyncUiQuestionsState } from './syncUi/types'
import { PlayInObject } from '../../../lib/playIn/types'
import { LayoutsSlice } from '../../slices/layouts'


export interface TwilioUIDocValueInterface {
  endingLive: boolean
  focusOn: string | null
  screenShareFocus: string | null
  gigTerminationTime: string
  goingLive: boolean
  liveDateTime: string | null
  liveEnded: boolean
  mediaType: mediaType
  mute: string[]
  playInMute: string[]
  participantInformation: ParticipantInformationInterface[]
  pendingSlidesId: null | string
  presenterCount: number
  slidePosition: SlidePosition
  videoDisplay: string[]
  autoSpotlight: boolean
  dominantSpeaker: string | null
  eventStreamUrl: string
  layouts: LayoutsSlice
  conversationCreatorId: string
  conversationName: string
  questions: SyncUiQuestionsState
}

export enum BridgeStatus {
  DOWN = 'DOWN',
  NODATA = 'NODATA',
  UP = 'UP'
}

export interface BridgeStateInterface {
  name: string
  status: BridgeStatus
}

export interface TwilioBookingDocValueInterface {
  status: status
}

export interface TwilioBridgeDataDocInterface extends SyncDocument {
  data: {
    primaryPresenter: BridgeStateInterface,
    secondaryPresenter: BridgeStateInterface
  }
}

export interface TwilioUIDocInterface extends SyncDocument {
  data: TwilioUIDocValueInterface
}

export interface TwilioBookingDocInterface extends SyncDocument {
  data: TwilioBookingDocValueInterface
}

export interface TwilioPlayInDoc extends SyncDocument {
  data: PlayInObject
}
